import RealizePrev from "../support";
import axios from "axios";

const api = axios.create({
  baseURL: RealizePrev().bU,
});

api.interceptors.request.use((request) => {
  request.headers.common["x-api-token"] = RealizePrev().hashHeader;

  return request;
});

api.interceptors.response.use((response) => {
  return response;
});

export default api;
